import { sendSignup } from '~/composables/useGtmEvents'

interface RegistrationRequest {
  email: string
  password: string
  first_name: string
  last_name: string
  company_name?: string
  newsletter?: boolean
}

interface ApiResponse {
  statusCode: number
  message: string
}

const useSignup = () => {
  const { verifyToken } = useAuth()
  const { fetchProfile, user } = useAccount()

  async function register(data: RegistrationRequest): Promise<void> {
    try {
      await $fetch<ApiResponse>('/api/auth/register/', {
        method: 'POST',
        body: data,
      })

      await verifyToken()
      await fetchProfile()
      sendSignup('form', user.value?.data?.id)
    } catch (err) {
      throw new Error(
        'Registration failed: ' +
          (err instanceof Error ? err.message : String(err))
      )
    }
  }

  return {
    register,
  }
}

export default useSignup
